// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iDzI","controls":"styles_controls__oOcEz","charLimit":"styles_charLimit__1i5ai","input":"styles_input__foScH","send":"styles_send__F2q1g"};